import { ReactNode } from 'react';

export function WetagsHeader({ children }: { children: ReactNode }) {
  return (
    <header style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
      {children}
    </header>
  );
}
